import React from "react";
import offerone from "../../assets/img/home-banner/Slider/offerone.webp"; // Desktop
import offeronemobile from "../../assets/img/home-banner/Slider/offeronemobile.webp"; // Mobile
import "../MainNavabar/MainNavabar.css";
import "./HomeBanner.css";
export default function HomeBanner() {
  return (
    <div className="container-fluid homebannersize p-0 m-0">
      <div className="mobile-imgae-space position-relative">
        <h1 className="position-absolute opacity-0">Kaawaii Cosmetics</h1>
        <picture>
          <source
            srcSet={offeronemobile}
            media="(max-width: 767px)"
          />
          <img
            src={offerone}
            width={1500}
            height={1000}
            className="w-100"
            alt="Buy 3 get 1 free Kaawaii Cosmetics"
            loading="eager"
            fetchpriority="high"
          />
        </picture>
      </div>
    </div>
  );
}
